import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames'
import Button from '@material-ui/core/Button';
import PropTypes from "prop-types";
const styles = theme => ({
	explainText:{
		color:'rgba(0,0,0,0.67)',
		marginBottom: 30
	},
	loginMainBox:{
		height:'85% !important',
		maxWidth:'700px !important',
		maxHeight:750
	},
	mailText:{
		color:'#40bad0',
	},
	cautionText:{
		fontSize:'90%',
		color:'rgba(0,0,0,0.67)',
		padding:20,
		backgroundColor:'rgba(0,0,0,0.05)',
		borderRadius:5,
		marginBottom: 20
	},
});


class ResetCompleteForm extends React.Component {
	render () {
		const { classes,auth } = this.props;
		const {mailAddress, limitMinutes} = auth;

		return (
			<div id="login_area">
				<div className={classNames("login_main_box",classes.loginMainBox)}>
					<h2>パスワード再設定申込完了</h2>
					<p className={classes.explainText}>
						パスワード再設定申込を受け付けました。<br/>
						<br/>
						パスワード再設定用ページのURLを記載したメールを<br/>
						<span className={classes.mailText}> {mailAddress}</span><br/>
						へ送信しましたので、ご確認ください。<br/>
						<br/>
						受信したメールに記載のURLより、パスワード再設定ページへアクセスし<br/>
						パスワード再設定を完了させてください。<br/>
					</p>
					<p className={classes.cautionText}>
						※URLの有効期限は{limitMinutes}です。{limitMinutes}内に再設定を完了させてください。<br/>
						※再設定用のメールが届かない場合は、メールアドレスの間違いがないか確認の上<br/>
						　再度操作を行なってください
					</p>
					<div className="btn_area">
						<Button variant="contained" color="primary" className="fl_right" onClick={this.props.backLoginFunc}>
							ログイン画面へ戻る
						</Button>
					</div>
					<p className="copyright fsm5 ta_center">TSUNAGUTE</p>
				</div>
			</div>
		);
	}
}

ResetCompleteForm.propTypes = {
	backLoginFunc:PropTypes.func
};

function mapStateToProps(state) {
	return {
		auth: state.auth
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(ResetCompleteForm);



// WEBPACK FOOTER //
// ./src/routes/menu/components/reset-complete-form.js